var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-numbers"},_vm._l((_vm.numbers),function(number){return _c('div',{key:number},[_vm._v(" "+_vm._s(number)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }